import validate from "/builds/namicomi/frontend/node_modules/.pnpm/nuxt@3.16.2_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.14.1_db0@0.3.1_es_8e02d0503ce026c1ba217ab2e6b93e92/node_modules/nuxt/dist/pages/runtime/validate.js";
import analytics_45global from "/builds/namicomi/frontend/middleware/analytics.global.ts";
import locale_45global from "/builds/namicomi/frontend/middleware/locale.global.ts";
import persist_45query_45global from "/builds/namicomi/frontend/middleware/persistQuery.global.ts";
import manifest_45route_45rule from "/builds/namicomi/frontend/node_modules/.pnpm/nuxt@3.16.2_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.14.1_db0@0.3.1_es_8e02d0503ce026c1ba217ab2e6b93e92/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  analytics_45global,
  locale_45global,
  persist_45query_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}